import LocationSearchPage from "./location-search";
export default LocationSearchPage;